import { useState, useEffect } from 'react';

/**
 * Custom hook that types out text character-by-character.
 * @param {string} text - Target text to type out
 * @param {number} speed - Delay in ms per character (default 55)
 * @param {number} startDelay - Initial delay in ms before typing starts (default 400)
 * @returns {string} Substring of text currently typed
 */
export function useTypewriter(text, speed = 55, startDelay = 400) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let interval;
    const timeout = setTimeout(() => {
      interval = setInterval(() => {
        setCount((c) => {
          if (c >= text.length) {
            clearInterval(interval);
            return c;
          }
          return c + 1;
        });
      }, speed);
    }, startDelay);
    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [text, speed, startDelay]);

  return text.slice(0, count);
}
